import React from "react";
import { cn } from "../../../../lib/utils";
import type { OptionNameValuePair } from "../../../../lib/interfaces/types";

interface HorizontalRadioPillsInputProps<T> {
  options: OptionNameValuePair<T>[];
  selectedValue?: T | null;
  onSelectionChange: (value: T) => void;
}

export function HorizontalRadioPillsInput<T>({
  options,
  selectedValue,
  onSelectionChange,
}: HorizontalRadioPillsInputProps<T>) {
  return (
    <div className="flex items-center gap-2">
      {options.map((option, index) => {
        const isChecked = selectedValue === option.value;
        const isDisabled = !!option.disabled;

        return (
          <label
            key={index}
            style={
              isChecked
                ? {
                    background: "linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), #3551F3",
                  }
                : undefined
            }
            className={cn(
              "flex items-center gap-3 rounded-[10px] border px-3 py-2 select-none",
              isDisabled
                ? "cursor-not-allowed opacity-80"
                : "cursor-pointer",
              isChecked
                ? "border-[#3551F3]"
                : "border-[#E5E5E5] bg-white"
            )}
          >
            <input
              type="radio"
              disabled={isDisabled}
              checked={isChecked}
              onChange={() => onSelectionChange(option.value)}
              className="sr-only"
            />

            <div
              className={cn(
                "flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border",
                isChecked
                  ? "border-[#3551F3] bg-[#3551F3]"
                  : "border-[#E5E5E5] bg-white"
              )}
            >
              {isChecked && <div className="h-2 w-2 rounded-full bg-white" />}
            </div>

            <span className="font-[Inter] text-[14px] font-medium leading-5 text-[#0A0A0A]">
              {option.name}
            </span>
          </label>
        );
      })}
    </div>
  );
}

export default HorizontalRadioPillsInput;